module.exports = __webpack_public_path__ + "img/5ne.6842b720.svg";